export const WORK_DIR_NAME = 'project';
export const WORK_DIR = `/home/${WORK_DIR_NAME}`;
export const DB_MIGRATIONS_DIR = `${WORK_DIR}/supabase/migrations`;
export const EDGE_FUNCTIONS_DIR = `${WORK_DIR}/supabase/functions`;
export const FILE_SELECTIONS_TAG_NAME = 'bolt_file_selections';
export const RUNNING_COMMANDS_TAG_NAME = 'bolt_running_commands';

export const CC_MAGIC_STRING = '626f6c742d63632d6167656e74';
export const CC_MAGIC_STRING_REGEX = new RegExp(`^${CC_MAGIC_STRING}`);

export const END_STREAM_BYTES = new Uint8Array([10, 10, 10]);

export const SUPABASE_DATABASE_REGEX = new RegExp('Supabase( database)?(?!\\.[a-zA-Z0-9.]+)', 'gi');

// https://github.com/supabase/cli/blob/11a9f429ac2ae2aa0f4ebbe038c1947baeb6ad9c/pkg/migration/file.go#L26
export const MIGRATION_FILENAME_REGEX = /^([0-9]+)_(.*)\.sql$/;

export const MAX_FILE_UPLOADS = 5;

export const FILE_SIZE_LIMIT_MB_ANTHROPIC = 5;
export const FILE_SIZE_LIMIT_MB_PERSONAL_TIER = 10;
export const FILE_SIZE_LIMIT_MB_PAID_TIER = 100;

/** Project's above this limit will save any exceeding files in `/api/projects/:slug/direct_uploads` instead */
export const PROJECT_SIZE_LIMIT_BYTES = 5_242_880;

/**
 * @note If you change this be aware that you could break `getDeploymentStatus` tool call.
 */
export const NO_DEPLOYMENT_STATUS_MESSAGE =
  'Use the deploy status we already know or tell the user something went wrong in case no status is known.';

export const SUBSCRIPTION_ACTIVATED_MESSAGE = 'Your subscription is now active';

export const SUPPORTED_PROMPT_FILE_TYPES_SET = new Set([
  // images
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.svg',

  // text files
  '.pdf',
  '.txt',
  '.doc',
  '.docx',
  '.py',
  '.ipynb',
  '.js',
  '.mjs',
  '.cjs',
  '.jsx',
  '.html',
  '.css',
  '.scss',
  '.sass',
  '.ts',
  '.tsx',
  '.java',
  '.cs',
  '.php',
  '.c',
  '.cc',
  '.cpp',
  '.cxx',
  '.h',
  '.hh',
  '.hpp',
  '.rs',
  '.swift',
  '.go',
  '.rb',
  '.kt',
  '.kts',
  '.scala',
  '.sh',
  '.bash',
  '.zsh',
  '.bat',
  '.csv',
  '.log',
  '.ini',
  '.cfg',
  '.config',
  '.json',
  '.yaml',
  '.yml',
  '.toml',
  '.lua',
  '.sql',
  '.md',
  '.tex',
  '.latex',
  '.asm',
  '.ino',
  '.s',
]);

export const SUPPORTED_PROMPT_FILE_TYPES_LIST = Array.from(SUPPORTED_PROMPT_FILE_TYPES_SET).join(',');

export const SELECTED_ACCOUNT_USER = 'USER';

// we mimic the name of the cookie used by segment, to ease a future migration
export const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
